import * as React from 'react';
import { isEqual } from 'vet-bones/utils';

import { ProjectVirtualGraphToCreate } from 'src/containers/ProjectResourceDialog/ProjectVirtualGraphCreationPanel/types';
import {
  ProjectVirtualGraph,
  ProjectVirtualGraphOptions,
} from 'src/store/state/projects';

export const useIsVgDirty = (
  savedVirtualGraph: ProjectVirtualGraph,
  localVirtualGraph: ProjectVirtualGraphToCreate | null,
  localVirtualGraphOptions: ProjectVirtualGraphOptions | null
) => {
  return React.useMemo(() => {
    if (!localVirtualGraph || !localVirtualGraphOptions) {
      return false;
    }

    const isNameChanged = savedVirtualGraph.name !== localVirtualGraph.name;
    if (isNameChanged) {
      return true;
    }

    const isFromChanged = !isEqual(
      savedVirtualGraph.from,
      localVirtualGraph.from
    );
    if (isFromChanged) {
      return true;
    }

    const areFieldsChanged =
      savedVirtualGraph.fields.length !== localVirtualGraph.fields.length ||
      savedVirtualGraph.fields.some((savedField, idx) => {
        const localField = localVirtualGraph.fields[idx];
        return (
          savedField.label !== localField.label ||
          savedField.value !== localField.value
        );
      });
    if (areFieldsChanged) {
      return true;
    }

    const areOptionsChanged = !isEqual(
      savedVirtualGraph.options,
      localVirtualGraphOptions
    );

    return areOptionsChanged;
  }, [localVirtualGraph, localVirtualGraphOptions, savedVirtualGraph]);
};
